import * as React from "react";
import './PageHeaderAstena.css';
import {
    ArrowLeftOutlined
} from "@ant-design/icons";

interface PageHeaderProps {
    title?: string | JSX.Element;
    subTitle?: string | JSX.Element;
    extra?: JSX.Element[];
    onBack?: () => void;
    style?: React.CSSProperties;
    className?: string;
}

const PageHeaderAstena = (props: PageHeaderProps) => {

    return (
        <div style={props.style} className={props.className}>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "baseline", justifyContent: "space-between" }}>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", overflow: "hidden" }}>
                    {props.onBack != null && (
                        <ArrowLeftOutlined onClick={props.onBack} style={{ marginRight: 16 }} className={"astena-page-header-back-button"} />
                    )}
                    <span className="astena-page-header-title" style={{ fontWeight: 600 }}>{props.title}</span>
                    <span className="astena-page-header-sub-title" style={{ color: "rgba(0,0,0,.45)", paddingLeft: 4 }}>{props.subTitle}</span>
                </div>
                {(props.extra != null && props.extra.length > 0) && (
                    <span style={{ whiteSpace: "nowrap", gap: 8, display: "inline-flex" }}>
                        {props.extra.map((x, i) => (
                            <span key={i}>
                                {x}
                            </span>

                        ))}
                    </span>
                )}
            </div>

        </div>
    )
}

export default PageHeaderAstena;